<template>
  <a-modal
    title="添加过滤条件组"
    width="800px"
    :open="open"
    transitionName=""
    maskTransitionName=""
    :destroyOnClose="true"
    :confirmLoading="loading"
    centered
    @ok="handleSubmit"
    @cancel="
      () => {
        $emit('cancel');
      }
    "
  >

    <a-tab-pane class="my-card" v-for="item in tab_list"
                :key="item.key" :tab="item.tab_name">
      <div v-for="base_search_item in item.base_search_list" :key="base_search_item.name">
        <div style="font-size: 14px;">{{base_search_item.name}}</div>
        <a-space wrap>
          <div  v-for="obj in base_search_item.group" :key="obj.field_name">
            <a-checkbox v-model:checked="obj.checked" >
              <span style="color:#7d8089">{{ obj.label }}</span>
            </a-checkbox>
          </div>
        </a-space>
      </div>
    </a-tab-pane>

    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane class="my-card" v-for="item in tab_list"
                  :key="item.key" :tab="item.tab_name">
        <div v-for="base_search_item in item.base_search_list" :key="base_search_item.name">
          <div style="font-size: 14px;">{{base_search_item.name}}</div>
          <a-space wrap style="padding-left: 10px; margin-bottom:0">
            <div  v-for="obj in base_search_item.group" :key="obj.field_name">
              <a-checkbox v-model:checked="obj.checked" >
                <span style="color:#7d8089">{{ obj.label }}</span>
              </a-checkbox>
            </div>
          </a-space>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
export default defineComponent({
  name: 'AddConditionGroupModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    default_search_condition_config_list: {
      type: Array,
      required: false,
    },
    base_search_condition_config_list: {
      type: Array,
      required: false,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props, { emit }) {
    const tab_list = ref([]);
    const get_operator_list_selected = (condition) => {
      if (condition.operator_list_selected) {
        return condition.operator_list_selected;
      }
      else if (condition.operator_list) {
        return condition.operator_list;
      }
      else {
        return [];
      }
    };
    props.default_search_condition_config_list?.forEach((item_list:any, index:number)=>{
      const base_search_list:any = JSON.parse(JSON.stringify(props.base_search_condition_config_list));
      if(base_search_list){
        base_search_list.forEach((base_search_list:any)=>{
          base_search_list.group.forEach(i=>{
            item_list.forEach((k:any)=>{
              if(i.field_name == k.field_name){
                i.checked = true;
              }
            });
          });
        });
      }
      tab_list.value.push({
        tab_name:`条件组${index+1}`,
        key:`condition_tab_${index}`,
        base_search_list: base_search_list,
      });
    });
    const index = props.default_search_condition_config_list?.length || 0;
    const new_search_list = [];
    props.base_search_condition_config_list.forEach((item:any)=>{
      const new_group = [];
      item.group.forEach(i=>{
        const operator_list_selected = get_operator_list_selected(i);
        if(i.default_operator){
          i.operator = i.default_operator;
        }
        if(!operator_list_selected.includes(i.operator)){
          i.operator = null;
        }
        if(!i.operator && operator_list_selected.length>0){
          const [first] = operator_list_selected;
          i.operator = first;
        }
        const new_i = { ...i, checked:false };
        new_group.push(new_i);
      });
      new_search_list.push({
        name:item.name,
        group:new_group,
      });
    });
    tab_list.value.push({
      tab_name:`条件组${index+1}`,
      key:`condition_tab_${index}`,
      base_search_list: new_search_list,
    });
    const activeKey = ref(`condition_tab_${index}`);

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      const list = [];
      tab_list.value.forEach(item=>{
        const selected_group_list:any = [];
        item.base_search_list.forEach(i=>{
          i.group.forEach((temp:any)=>{
            if(temp.checked){
              selected_group_list.push(temp);
            }
          });
        });
        if(selected_group_list.length>0){
          list.push(selected_group_list);
        }
      });
      if(list.length==0){
        message.error('新增条件组未增加新的字段，自动取消');
        emit('cancel');//关闭对话框
      }else{
        emit('ok', { new_list: list });
      }
    };

    return {
      props,
      activeKey,
      tab_list,
      handleSubmit,
      get_operator_list_selected,
    };
  },
});
</script>
<style scoped>
.my-card{
  padding:20px;
  background-color: #f6f7f9;
}
</style>